import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import React, { useCallback, useState } from 'react';

export interface LogoutLabels {
  label?: string;
  confirmTitle?: string;
  confirmBody?: string;
  confirmButton?: string;
  cancelButton?: string;
}

export interface LogoutProps {
  logout: () => void;
  labels?: LogoutLabels;
}

const Logout: React.FC<LogoutProps> = ({ logout, labels = {} }) => {
  const [open, setOpen] = useState(false);

  const openConfirm = useCallback(() => setOpen(true), []);
  const closeConfirm = useCallback(() => setOpen(false), []);
  const confirmLogout = useCallback(() => {
    setOpen(false);
    logout();
  }, [logout]);

  return (
    <>
      <MenuItem sx={{ color: 'error.main' }} onClick={openConfirm}>
        {labels.label || 'Log out'}
      </MenuItem>
      <Dialog open={open} onClose={closeConfirm}>
        <DialogTitle>{labels.confirmTitle || 'Confirm logout'}</DialogTitle>
        <DialogContent>
          <DialogContentText>{labels.confirmBody || 'Are you sure you want to log out?'}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={closeConfirm}>
            {labels.cancelButton || 'Cancel'}
          </Button>
          <Button onClick={confirmLogout} sx={{ color: 'error.main' }}>
            {labels.confirmButton || 'Log out'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Logout;
